<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div class="ld-panel-title">
		<h2 class="back-btn">通知设置</h2>
	</div>
	<div class="ld-panel-main">
		<el-alert title="温馨提示：业务到期前15天左右我司会进行人工通知，如果您不需要电话通知，可以取消。 如果您的联系方式不正确，请及时修改会员资料，否则不能收到续费通知。" type="warning" show-icon :closable="false" />
		<el-form :model="groupForm" :label-width="formLabelWidth" class="form-main">
			<el-form-item label="续费通知设置">
				<el-checkbox v-model="groupForm.noticesms" true-label='1' false-label='0' border label="手机短信" />
				<el-checkbox v-model="groupForm.noticeemail" true-label='1' false-label='0' border label="电子邮件" />
				<el-checkbox v-model="groupForm.noticetel" true-label='1' false-label='0' border label="人工电话" />
			</el-form-item>
			<el-form-item label="微信推送设置">
				<el-checkbox-group v-model="groupForm.noticewx">
					<el-checkbox border v-for="item in weixinNotice" :key="item.values" :label="item.values">{{item.name}}</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submitForm">提交</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue'
	import { getUserInfo,getconstinfo,noticeSetting } from '@/api/account';
	import sideNav from '../../components/sideNav.vue'
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const pageTitle = 'account';
	const userInfo = ref('');
	const weixinNotice = ref();
	const formLabelWidth = ref('160px');
	const groupForm = ref({noticesms:'0',noticeemail:'0',noticetel:'0',noticewx:[]});

	const fetchListF = () => {
		getUserInfo().then((res) => {
			if(res.code === 200){
				groupForm.value.noticesms = res.data.noticeSms.toString();
				groupForm.value.noticeemail = res.data.noticeEmail.toString();
				groupForm.value.noticetel = res.data.noticeTel.toString();
				groupForm.value.noticewx = res.data.noticeWeixin.split(",");
			}
		})
		getconstinfo('wxnotice').then((res) => {
			weixinNotice.value = res.data
		})
	};
	const submitForm = () => {
		groupForm.value.noticesms = parseInt(groupForm.value.noticesms);
		groupForm.value.noticeemail = parseInt(groupForm.value.noticeemail);
		groupForm.value.noticetel = parseInt(groupForm.value.noticetel);
		const param = groupForm.value;
		noticeSetting(param).then((res) => {
			if(res.code === 200){
				ElMessage({
					offset:70,
					message: res.msg,
					type: 'success'
				})
				fetchListF()
			}
		})
	};
	
	onMounted(() => {
		fetchListF();
	});
	
</script>

<style scoped>
	.el-checkbox{margin-bottom: 10px !important;}
</style>